import uuid from 'uuid/v4';
import { action, ActionType } from 'typesafe-actions';
import { Step, SendingMethod } from './types';
import { Props } from './index';

export const ACTIVATE = 'FULL_REGISTRATION/ACTIVATE';
export const DEACTIVATE = 'FULL_REGISTRATION/DEACTIVATE';
export const GO_TO_STEP = 'FULL_REGISTRATION/GO_TO_STEP';
export const SET_SUGGESTED_LOGIN = 'FULL_REGISTRATION/SET_SUGGESTED_LOGIN';
export const FINISH = 'FULL_REGISTRATION/FINISH';
export const RESET = 'FULL_REGISTRATION/RESET';
export const SAVE_CREDENTIALS = 'FULL_REGISTRATION/CREDENTIALS/SAVE';
export const SET_CODE_SOURCE = 'FULL_REGISTRATION/CODE_SOURCE/SET';
export const RESET_SESSION_ID = 'FULL_REGISTRATION/SESSION_ID/SET';

export const actions = {
  goToStep: (step: Step) => action(GO_TO_STEP, { step }),
  finish: () => action(FINISH),
  setSuggestionLogin: (login: string) => action(SET_SUGGESTED_LOGIN, { login }),
  saveCredentials: (login: string, password: string) =>
    action(SAVE_CREDENTIALS, { login, password }),
  setCodeSource: (source: SendingMethod) => action(SET_CODE_SOURCE, { source }, { ts: Date.now() }),
  reset: () => action(RESET),
  resetSessionId: () => action(RESET_SESSION_ID, { sessionId: uuid() }),
};

export const lifecycle = {
  activate: (props: Props) => action(ACTIVATE, { ...props }),
  deactivate: () => action(DEACTIVATE),
};

export type Action = ActionType<typeof actions>;
export type LifeCycleAction = ActionType<typeof lifecycle>;
